<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" xl="12" xxl="12" xs="12" sm="12">
        <CTableWrapper
          :items="data"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          caption="Lista de Convenios"
          icon="fas fa-coins"
          btn_name="Convenio"
          @mtdBack="mtdBack"
          @show_modal="mtd_open_modal"
          @action_edit="mtd_show"
          @action_delete="mtd_delete"
          :size="'md'"
          :button_new="true"
          :actions="true"
          :withActions="'2%'"
          :buttonEdit="true"
          :buttonDelete="true"
          :myButtons="myButtons"
          @mtdAddClient="mtdAddClient"
          @mtdAddDiscount="mtdAddDiscount"
        />
      </CCol>
    </CRow>

    <!-- modal -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="modal.title"
      :button="cp_button"
      :show.sync="modal.modal_form"
      @mtd_action="mtd_action"
      :color="'info'"
      :centered="true"
    >
      <CRow>
        <CCol xl="10" lg="10" md="10" sm="10" xs="10">
          <CInput
            label="RUC"
            placeholder="Digite RUC"
            v-model="agreement.ruc"
            maxlength="11"
            @input="validateRUC"
            v-on:keypress="isNumber($event)"
            @keypress.enter="mtdSearchDocument"
          />
          <span v-if="errors.ruc" class="text-danger">{{ errors.ruc }}</span>
        </CCol>
        <CCol xl="2" lg="2" md="2" sm="2" xs="2" class="mt-1 my-auto col-3">
          <CButton
            class="w-100 mt-2"
            color="info"
            v-c-tooltip.hover="{ content: `Buscar documento` }"
            @click="mtdSearchDocument"
          >
            <i class="fas fa-search"></i>
          </CButton>
        </CCol>
        <CCol sm="12">
          <CInput
            label="Nombre"
            placeholder="Digite nombre"
            v-model="agreement.name"
          />
        </CCol>
        <!-- <CCol sm="12">
          <CInput
            label="Telefono"
            placeholder="Digite telefono"
            v-model="provider.phone"
            maxlength="9"
            @input="validatePhone"
          />
          <span v-if="errors.phone" class="text-danger">{{
            errors.phone
          }}</span>
        </CCol>
        <CCol sm="12">
          <CInput
            label="Representante"
            placeholder="Digite representante"
            v-model="provider.vendor"
          />
          <span v-if="errors.vendor" class="text-danger">{{
            errors.vendor
          }}</span>
        </CCol> -->
        <CCol v-if="modal.action != 'store'" sm="12">
          <label for="">Estado</label>
          <CSwitchVue
            :key="componentKey"
            @changeSwitch="changeSwitch"
            class="mx-1 pl-2 pt-2"
            :checked="agreement.state == 1 ? true : false"
            color="success"
            variant="opposite"
            shape="pill"
            v-bind="labelIcon"
          />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal delete -->
    <cModalDelete
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="'Borrar Convenio'"
      :show.sync="modal_delete.boo"
      @mtd_commit="mtd_commit"
      :centered="true"
      :item="modal_delete.item"
    />

    <!-- modal catergorie -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'lg'"
      :title="modalCategorie.title"
      :show.sync="modalCategorie.modal_form"
      :color="'info'"
      :centered="true"
      :show_boton="false"
    >
      <CRow>
        <CCol xl="6" xxl="6" md="6" sm="12" xs="12">
          <h4>Categorias</h4>
          <template v-for="(item, index) in dataCategories">
          <CCard
            :key="index"
            v-if="!item.select"
            :accent-color="mtdGetClassNoIn(item.select)"
            :border-color="mtdGetClassNoIn(item.select)"
          >
              <CCardHeader @click="mtdSelectCategorie(item, index)">
                {{ item.name }}
                <CBadge
                  :color="mtdGetClassNoIn(item.select)"
                  class="float-right"
                  >{{ item.select ? "Seleccionado" : "Seleccionar" }}</CBadge
                >
              </CCardHeader>
            </CCard>
          </template>
        </CCol>
        <CCol xl="6" xxl="6" md="6" sm="12" xs="12">
          <h4>Seleccionados</h4>
          <CCard
            v-for="(item, index) in categorieSelect"
            :key="index"
            :accent-color="'info'"
            :border-color="'info'"
          >
            <CCardHeader @click="mtdSelectCategorieSelect(item, index)">
              {{ item.nameCat }}
              <CBadge color="info" class="float-right">{{
                item.amount
              }}</CBadge>
            </CCardHeader>
          </CCard>
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal cliente -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'xl'"
      :title="modalClient.title"
      :button="cp_button"
      :show.sync="modalClient.modal_form"
      :color="'info'"
      :centered="true"
    >
      <CRow>
        <CCol xl="6" xxl="6" md="6" sm="12" xs="12">
          <h4>Clientes</h4>
          <template v-for="(item, index) in dataClients">
          <CCard
            :key="index"
            v-if="!item.select"
            :accent-color="mtdGetClassNoIn(item.select)"
            :border-color="mtdGetClassNoIn(item.select)"
          >
              <CCardHeader @click="mtdSelectClient(item, index)">
                {{ item.name }}
                <CBadge
                  :color="mtdGetClassNoIn(item.select)"
                  class="float-right"
                  >{{ item.select ? "Seleccionado" : "Seleccionar" }}</CBadge
                >
              </CCardHeader>
            </CCard>
          </template>
        </CCol>
        <CCol xl="6" xxl="6" md="6" sm="12" xs="12">
          <h4>Seleccionados</h4>
          <CCard
            v-for="(item, index) in clientSelect"
            :key="index"
            :accent-color="'info'"
            :border-color="'info'"
          >
            <CCardHeader @click="mtdSelectClientSelect(item, index)">
              {{ item.name }}
            </CCardHeader>
          </CCard>
        </CCol>
      </CRow>
    </CModalForm>
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "ruc", label: "RUC", _style: "width:20%;" },
  { key: "name", label: "Nombre", _style: "width:20%;" },
  //   { key: "phone", label: "Telefono", _style: "width:20%;" },
  //   { key: "vendor", label: "Representante", _style: "width:20%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
];

import CTableWrapper from "../../shared/datatable/Table.vue";
import CModalForm from "../../shared/modals/cModalForm.vue";
import cModalDelete from "../../shared/modals/cModalDelete.vue";
import { mapActions } from "vuex";
import CSwitchVue from "../../shared/switch/CSwitch.vue";

export default {
  components: { CTableWrapper, CModalForm, cModalDelete, CSwitchVue },
  data() {
    return {
      prefix: "agreement",
      fields,
      data: [],
      dataCategories: [],
      categorieSelect: [],
      clientSelect:[],
      dataClients:[],
      myButtons: [
        {
          class: "btn-sm text-white",
          color: "warning",
          tooltip: "Agregar Descuentos",
          action: "mtdAddDiscount",
          icon: "fas fa-dollar-sign",
        },
        {
          class: "btn-sm",
          color: "dark",
          tooltip: "Agregar Clientes",
          action: "mtdAddClient",
          icon: "fas fa-user-plus",
        },
      ],
      modal: {
        action: "",
        title: "",
        modal_form: false,
      },
      modalCategorie: {
        modal_form: false,
        idAgreement: 0,
      },
      modalClient: {
        modal_form: false,
        idAgreement: 0,
      },
      agreement: {
        id: "",
        company_id: this.$store.getters.get_company.id,
        name: "",
        ruc: "",
        state: 0,
      },
      errors: {
        phone: "",
        ruc: "",
        vendor: "",
      },
      modal_delete: {
        boo: false,
        item: [],
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
      // dataStore: [],
    };
  },
  computed: {
    cpStatus: function () {
      if (this.agreement.state == 1) return true;
      return false;
    },
    cp_button: function () {
      return (
        this.errors.ruc !== "" ||
        this.agreement.name === "" ||
        this.agreement.ruc === ""
      );
    },
  },
  created() {
    this.mtd_getdata();
  },
  methods: {
    ...mapActions(["get", "post", "delete"]),
    mtd_getdata: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/index/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data = response.data.data;
          let index = 1;
          this.data.forEach((arr) => {
            arr.index = index;
            index++;
          });
          this.dataCategories = response.data.categorie;
          this.dataClients=response.data.clients;
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    mtd_open_modal: function (boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      action == "store"
        ? (this.modal.title = "Nuevo Convenios")
        : (this.modal.title = "Editar Convenios");
      action == "store"
        ? (this.agreement = {
            id: "",
            company_id: this.$store.getters.get_company.id,
            name: "",
            ruc: "",
            state: 0,
          })
        : (this.agreement = { ...this.agreement });
      if (this.modal.action != "store") {
        this.componentKey += 1;
      }
    },
    mtd_action: function () {
      if (!this.validateForm()) return;
      this.post({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/" +
          this.modal.action,
        token: this.$store.getters.get__token,
        params: this.agreement,
      })
        .then((response) => {
          if (response.data.state == 1 || response.data.state == 2) {
            if (response.data.state == 1) {
              Swal.fire({
                title: "Convenio ya resgistrado",
                icon: "warning",
              });
            } else {
              Swal.fire({
                title: "RUC ya resgistrado",
                icon: "warning",
              });
            }
          } else {
            let color = "success";
            let message = "";
            if (this.modal.action == "store") {
              message = "REGISTRADO CORRECTAMENTE";
              this.mtd_getdata();
            } else {
              let updatedProvider = response.data.data;
              let index = this.data.findIndex(
                (provider) => provider.id === updatedProvider.id
              );
              if (index !== -1) {
                this.$set(this.data, index, updatedProvider);
              }
              message = "EDITADO CORRECTAMENTE";
              this.mtd_getdata();
            }
            this.modal = {
              action: "",
              title: "",
              modal_form: false,
              name: "",
            };
            this.agreement = {
              id: "",
              company_id: this.$store.getters.get_company.id,
              name: "",
              ruc: "",
              state: 0,
            };

            Swal.fire({
              title: message,
              icon: color,
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_show: function (id) {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.agreement = response;
          this.mtd_open_modal(true, "update");
        })
        .catch((errors) => {});
    },
    mtd_delete: function (item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete: function () {
      this.modal_delete.boo = false;
    },
    mtd_commit: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.id,
        },
      })
        .then((response) => {
          let temp = [];
          this.data.forEach((element) => {
            if (element.id != response.data.id) {
              temp.push(element);
            }
          });
          this.data = temp;
          this.modal_delete = {
            boo: false,
            item: [],
          };

          Swal.fire({
            title: "ELIMINADO CORRECTAMENTE",
            icon: "success",
          });
        })
        .catch((errors) => {});
    },
    changeSwitch: function (payload) {
      this.agreement.state = payload == true ? 1 : 0;
    },
    mtdSearchDocument: function () {
      if (this.agreement.ruc.length == 11) {
        this.get({
          url:
            this.$store.getters.get__url + "/Consultas/" + this.agreement.ruc,
          token: this.$store.getters.get__token,
        }).then((response) => {
          if (response.data.boo == 3) {
            this.agreement.name = "";
            this.agreement.address = "";
            Swal.fire({
              title: "Ruc no encontrado",
              icon: "warning",
            });
          } else {
            this.agreement.name = response.data.razon_social;
            this.agreement.address = response.data.direccion;
          }
        });
      }
    },
    validateRUC() {
      // Filtra solo los caracteres numéricos
      this.agreement.ruc = this.agreement.ruc.replace(/\D/g, "");

      if (this.agreement.ruc.length != 11) {
        this.errors.ruc = "El RUC debe ser un número de máximo 11 dígitos";
      } else {
        this.errors.ruc = "";
      }
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validateForm() {
      this.validateRUC();
      //   this.validatePhone();
      return (
        this.errors.ruc === "" &&
        this.errors.phone === "" &&
        this.errors.vendor === ""
      );
    },
    /*** agregar descuento */
    mtdAddDiscount: function (payload) {
      this.categorieSelect = [];
      this.modalCategorie.title = "AGREGAR DESCUENTOS A CATEGORIAS";
      const temp = payload.detail;
      this.modalCategorie.idAgreement = payload.Id;
      this.modalCategorie.modal_form = true;
      temp.forEach((element) => {
        this.categorieSelect.push({
          id: element.id,
          idCate:element.categorie_id,
          nameCat: element.categorie.name,
          amount: element.amount,
        });
      });
      this.dataCategories.forEach((element) => {
        const estaEnSelect = this.categorieSelect.some(
          (b) => b.idCate == element.id
        );
        if (estaEnSelect) {
          element.select = true;
        } else {
          element.select = false;
        }
      });
    },
    mtdGetClassNoIn: function (boo) {
      if (boo) {
        return "success";
      } else {
        return "warning";
      }
    },
    mtdSelectCategorie: function (categorie, pos) {
      const idCate = categorie.id;
      const estaEnSelect = categorie.select;
      if (!estaEnSelect) {
        let quantity = "";
        Swal.fire({
          title: "Cantidad en %",
          html: `
          <input id="input-quantity" class="swal2-input" placeholder="Cantidad" value="${quantity}">`,
          icon: "info",
          showCancelButton: true,
          preConfirm: () => {
            const quantity =
              document.getElementById("input-quantity")?.value || "";
            if (!quantity) {
              Swal.showValidationMessage("Cantidad son obligatorios");
              return null;
            }
            return { quantity };
          },
        }).then((inputResult) => {
          if (inputResult.isConfirmed && inputResult.value) {
            const { quantity } = inputResult.value;
            this.mtdActionAddCategorie(quantity, idCate, categorie.name, pos);
          }
        });
      }
    },
    mtdActionAddCategorie: function (quantity, idCate, name, pos) {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/addCategorie",
        params: {
          agreement: this.modalCategorie.idAgreement,
          quantity: quantity,
          categorie: idCate,
        },
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.categorieSelect.push({
            id: response.data.id,
            idCate:idCate,
            nameCat: name,
            amount: quantity,
          });
          this.dataCategories = this.dataCategories.map(el =>
            el.id === idCate ? { ...el, select: true } : el
          );
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdSelectCategorieSelect: function (payload, pos) {
      Swal.fire({
        title: "Cantidad en %",
        html: `
    <input id="input-quantity" class="swal2-input" placeholder="Cantidad" value="${payload.amount}">
  `,
        icon: "info",
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: "Guardar",
        denyButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        preConfirm: () => {
          const quantity =
            document.getElementById("input-quantity")?.value || "";
          if (!quantity) {
            Swal.showValidationMessage("La cantidad es obligatoria");
            return null;
          }
          return { quantity };
        },
      }).then((result) => {
        // Confirmación de edición
        if (result.isConfirmed && result.value) {
          const { quantity } = result.value;
          Swal.fire({
            title: "¿Guardar cambios?",
            text: `Vas a actualizar la cantidad a: ${payload.amount}`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, guardar",
            cancelButtonText: "Cancelar",
          }).then((confirmResult) => {
            if (confirmResult.isConfirmed) {
              this.mtdActionEditCategorie(quantity, payload.id);
              this.categorieSelect[pos].amount = quantity;
            }
          });
        }
        // Confirmación de eliminación
        else if (result.isDenied) {
          Swal.fire({
            title: "¿Eliminar categoría?",
            text: "Esta acción no se puede deshacer.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar",
          }).then((deleteResult) => {
            if (deleteResult.isConfirmed) {
              this.mtdActionDeleteCategorie(payload.id);
              this.categorieSelect.splice(pos);
              this.dataCategories = this.dataCategories.map(el =>
                el.id === payload.idCate ? { ...el, select: false } : el
              );
            }
          });
        }
      });
    },
    mtdActionEditCategorie: function (quantity, idDet) {
      this.post({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/editCategorie",
        params: {
          id: idDet,
          quantity: quantity,
        },
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          // console.log(response);
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdActionDeleteCategorie: function (idDet) {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/deleteCategorie/" +
          idDet,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          // console.log(response);
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    /** agregar clientes */
    mtdAddClient: function (payload) {
      this.clientSelect = [];
      this.modalClient.title = "AGREGAR CLIENTES AL CONVENIO";
      const temp = payload.clients;
      this.modalClient.idAgreement = payload.Id;
      this.modalClient.modal_form = true;
      temp.forEach((element) => {
        this.clientSelect.push({
          id: element.id,
          name: element.name
        });
      });
      this.dataClients.forEach((element) => {
        const estaEnSelect = this.clientSelect.some(
          (b) => b.id == element.id
        );
        if (estaEnSelect) {
          element.select = true;
        } else {
          element.select = false;
        }
      });
    },
    mtdSelectClient: function(client,pos){
      const idClient = client.id;
      const estaEnSelect = client.select;
      if (!estaEnSelect) {
        Swal.fire({
          title: "¿Desea Agregar este cliente?",
          icon: "question",
          showCancelButton: true,
        }).then((inputResult) => {
          if (inputResult.isConfirmed && inputResult.value) {
            this.mtdActionAddClient(idClient, pos,client.name);
          }
        });
      }
    },
    mtdActionAddClient:function(client,pos,name){
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/addClient",
        params: {
          agreement: this.modalClient.idAgreement,
          client: client,
        },
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.clientSelect.push({
            id: client,
            name: name,
          });
          this.dataClients = this.dataClients.map(el =>
            el.id == client ? { ...el, select: true } : el
          );
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdSelectClientSelect: function(payload,pos){
      Swal.fire({
        title: "¿Desea eliminar este cliente del convenio?",
        icon: "info",
        showCancelButton: true,
        showDenyButton: true,
        showConfirmButton: false,
        denyButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => { if (result.isDenied) {
          Swal.fire({
            title: "¿Eliminar cliente de convenio?",
            text: "Esta acción no se puede deshacer.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar",
          }).then((deleteResult) => {
            if (deleteResult.isConfirmed) {
              this.mtdActionDeleteClient(payload.id);
              this.clientSelect.splice(pos);
              
            }
          });
        }
      });
    },
    mtdActionDeleteClient: function(client){
      this.get({
        url: this.$store.getters.get__url + "/" + this.prefix + "/delClient/"+client,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.dataClients = this.dataClients.map(el =>
            el.id == client ? { ...el, select: false } : el
          );
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    }
  },
  destroyed() {
    // console.log(this.dataStore);
    // this.$store.commit("mt_set_datacampus", this.dataStore);
  },
};
</script>

<style lang="scss" scoped>
.btn-search {
  color: #fff;
  background-color: #2819ae;
  border-color: #2517a3;
}
</style>
